var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16637 3.16636C4.65852 1.67424 6.72205 0.75 9 0.75C11.278 0.75 13.3415 1.67424 14.8336 3.16637L14.3033 3.6967L14.8336 3.16637C16.3258 4.65852 17.25 6.72205 17.25 9C17.25 11.278 16.3258 13.3415 14.8336 14.8336C13.3415 16.3258 11.278 17.25 9 17.25C6.72205 17.25 4.65852 16.3258 3.16637 14.8336L3.6967 14.3033L3.16637 14.8336C1.67424 13.3415 0.75 11.278 0.75 9C0.75 6.72205 1.67424 4.65852 3.16636 3.16637L3.16637 3.16636ZM9.9375 5.0625C9.9375 4.54474 9.51776 4.125 9 4.125C8.48224 4.125 8.0625 4.54474 8.0625 5.0625C8.0625 5.58026 8.48224 6 9 6C9.51776 6 9.9375 5.58026 9.9375 5.0625ZM8.4375 6.75C8.02329 6.75 7.6875 7.08579 7.6875 7.5C7.6875 7.91421 8.02329 8.25 8.4375 8.25V12H7.875C7.46079 12 7.125 12.3358 7.125 12.75C7.125 13.1642 7.46079 13.5 7.875 13.5H9.1875H10.5C10.9142 13.5 11.25 13.1642 11.25 12.75C11.25 12.3358 10.9142 12 10.5 12H9.9375V7.5C9.9375 7.08579 9.60172 6.75 9.1875 6.75H8.4375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.95ad2090c3ba82a2dd8d0d347c167581.svg";
export { ForwardRef as ReactComponent };